import { gettext } from '@eventbrite/i18n';

export const SIGN_IN_METHOD_PASSWORD = 'password';

export const SIGN_IN_METHOD_FACEBOOK_LOGIN = 'facebook_login';
export const SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK = 'facebook';

export const SIGN_IN_METHOD_APPLE_LOGIN = 'apple_login';
export const SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE = 'apple';

export const SIGN_IN_METHOD_GOOGLE_LOGIN = 'google_login';
export const SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE = 'google';

export const LINK_SOCIAL_ACCOUNT_SUCCESS = 'LINK_SOCIAL_ACCOUNT_SUCCESS';
export const UNLINK_SOCIAL_ACCOUNT_SUCCESS = 'UNLINK_SOCIAL_ACCOUNT_SUCCESS';

export const SOCIAL_EXTERNAL_IDENTITY_PROVIDER_MESSAGES = {
    [LINK_SOCIAL_ACCOUNT_SUCCESS]: {
        [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK]: gettext(
            'Your Facebook account is successfully connected to Eventbrite.',
        ),
    },
    [UNLINK_SOCIAL_ACCOUNT_SUCCESS]: {
        [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK]: gettext(
            'Your Facebook account is successfully disconnected from Eventbrite.',
        ),
    },
};

export const OTHER_LOGIN_METHODS = gettext('Other login methods');

export const OTHER_SIGN_UP_METHODS = gettext('Other sign up methods');

export const DATA_HEAP_ID_LOGIN_WITH_GOOGLE_BUTTON =
    'auth-signin-login_with_google_button-click';
export const DATA_HEAP_ID_LOGIN_WITH_FACEBOOK_BUTTON =
    'auth-signin-login_with_facebook_button-click';
export const DATA_HEAP_ID_LOGIN_WITH_APPLE_BUTTON =
    'auth-signin-login_with_apple_button-click';
export const HEAP_SOCIAL_LOGIN_EVENT =
    'Identity -Login - All - Submit - Social Login Attempt';
export const HEAP_FIND_MY_TICKETS_EVENT =
    'Identity -Help -Center -All -View -Find -Tickets -GTA';
